import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { InfoItem } from '../info.component';

type IntegrationLink = { url: string; title: string };

@Component({
  selector: 'md-other-integrations-info',
  imports: [TranslateModule, MatIconModule],
  templateUrl: './other-integrations-info.component.html',
  styleUrl: './other-integrations-info.component.scss',
  standalone: true
})
export class OtherIntegrationsInfoComponent {
  integrationsItem = input<InfoItem | undefined>(undefined);

  protected integrationUrls = computed((): IntegrationLink[] => {
    const urls: IntegrationLink[] = [];

    const hubSpotUrl = this.buildHubSpotUrl();
    if (hubSpotUrl) {
      urls.push({ url: hubSpotUrl, title: 'HubSpot' });
    }

    const helos20Url = this.buildHelos20Url();
    if (helos20Url) {
      urls.push({ url: helos20Url, title: 'Helos 2.0' });
    }

    return urls;
  });

  protected integrationType = computed(() => {
    const item = this.integrationsItem();
    if (!item?.type) return '';

    const type = item.type.toLowerCase();
    switch (type) {
      case 'haulier':
      case 'slaughterhouse':
        return 'Kumppani';
      case 'byproduct':
      case 'endproduct':
        return 'Tuote';
      case 'serviceproduct':
        return 'Palvelu';
      default:
        return '';
    }
  });

  private buildHubSpotUrl(): string | undefined {
    const item = this.integrationsItem();
    if (!item) return undefined;

    const type = item.type?.toLowerCase();
    const isPartner = type === 'haulier' || type === 'slaughterhouse';
    const hasHubSpotId = 'hubSpotId' in item && item['hubSpotId'];

    if (!isPartner || !hasHubSpotId) return undefined;

    return `${environment.hubspot.baseUrl}/contacts/${environment.hubspot.portalId}/record/0-2/${item['hubSpotId']}`;
  }

  private buildHelos20Url(): string | undefined {
    const item = this.integrationsItem();
    if (!item?.id) return undefined;

    const isByProduct = item.type?.toLowerCase() === 'byproduct';
    if (!isByProduct) return undefined;

    return `${environment.helos20.baseUrl}/admin/by-products/manage/edit/byproduct/${item.id}`;
  }
}
